// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__NOzFE","activeNav":"styles_activeNav__2O0ad","envLabel":"styles_envLabel__F-32k"};